





















































































































































































import { Component, Inject, Mixins } from "vue-property-decorator";
import {
  ICProdProvider,
  ICProdProviderMethods
} from "@/models/providers/contractProduct";
import Context from "@/mixins/context";

@Component({
  components: {
    "cprod-price-tax-summary": () =>
      import(
        "@/components/app/global/contractProducts/cProdPriceTaxSummary.vue"
      ),
    "cprod-status-reason-tooltip": () =>
      import(
        "@/components/app/global/contractProducts/cProdStatusReasonTooltip.vue"
      )
  }
})
export default class CProdDetailsTable extends Mixins(Context) {
  // Inject

  @Inject({ from: "contractProductProvider" })
  public readonly $cProdData!: () => ICProdProvider;

  @Inject({ from: "contractProductProviderMethods" })
  public readonly $cProdMethods!: ICProdProviderMethods;

  // Computed

  public get cProdData() {
    return this.$cProdData();
  }

  public get cProd() {
    return this.cProdData.contractProduct;
  }
}
